import { useEffect, useRef } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";

interface KnowledgeIframeProps {
  mesvaccinsUrl: string;
}

export function KnowledgeIframe({ mesvaccinsUrl }: KnowledgeIframeProps) {
  const iframeRef = useRef<HTMLIFrameElement>(null);

  const navigate = useNavigate();
  const location = useLocation();

  const { "*": path } = useParams();

  const targetIframePath = `${mesvaccinsUrl}/${path ?? ""}`;

  // Keep track of the current iframe path to avoid unnecessary updates
  const currentIframePathRef = useRef<string | null>(null);

  // If new iframe path does not match the current iframe path, update it
  useEffect(() => {
    if (targetIframePath !== currentIframePathRef.current) {
      if (iframeRef.current) {
        iframeRef.current.src = targetIframePath;
        currentIframePathRef.current = targetIframePath;
      }
    }
  }, [targetIframePath]);

  useEffect(() => {
    function onMessage(e: MessageEvent) {
      if (e.origin !== mesvaccinsUrl) return;

      const iframeWin = iframeRef.current?.contentWindow;
      if (!iframeWin || e.source !== iframeWin) return;

      const data = e.data;
      if (!data?.path) return;

      const newpath = `/knowledge${data.path}`;

      if (location.pathname !== newpath) {
        currentIframePathRef.current = `${mesvaccinsUrl}${data.path}`;
        navigate(newpath, { replace: true });
      }
    }

    window.addEventListener("message", onMessage);
    return () => window.removeEventListener("message", onMessage);
  }, [navigate, location.pathname, mesvaccinsUrl]);

  return (
    <iframe
      ref={iframeRef}
      width="100%"
      height="100%"
      title="Mesvaccins - Vaccines Documentation"
      sandbox="allow-scripts allow-same-origin allow-popups allow-popups-to-escape-sandbox allow-forms allow-downloads"
      loading="lazy"
      frameBorder="0"
    />
  );
}
